<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("sessionbigtitle") }}</span>
      </div>
      <div class="small-title sb-title">{{ $t("sessiontitle") }}</div>
      <div class="people-lists">
        <div class="people-list" v-for="(item, index) in $t('sessionText18')" :key="index">
          <div class="people-list-pic">
            <img :src="'http://mk.chinaman.cn/mybigdatas/ids/static/people-' +
              item.num +
              '.png'
              " alt="" />
          </div>
          <div class="people-list-title">
            {{ item.title }}
          </div>
          <div class="people-list-text">{{ item.text }}</div>
          <div class="people-list-text">{{ item.tip }}</div>
        </div>
      </div>
      <!-- <div class="small-title mt-50">IDS 2024 – Technical Sessions：</div>
      <div class="text">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="Paper ID" label="Paper ID"> </el-table-column>
          <el-table-column prop="Authors" label="Authors"> </el-table-column>
          <el-table-column prop="Organizations" label="Organization">
          </el-table-column>
          <el-table-column prop="Title" label="Title"> </el-table-column>
        </el-table>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],

    };
  },
};
</script>


<style scoped>
.sb-title {
  color: #0270c0 !important;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 230px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.mt-50 {
  margin-top: 50px;
}

.people-lists {
  display: flex;
  padding-bottom: 60px;
  flex-wrap: wrap;
}

.people-list {
  width: 20%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 20px;
  text-align: center;
}

.people-list-pic {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 auto 10px;
  background: #666;
  border: 2px solid #333;
}

.people-list-title {
  margin-bottom: 3px;
}

.people-list-text {
  font-weight: 600;
}

.people-list-pic img {
  width: auto;
  height: 110%;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .index {
    padding: 40px 10px 40px;
    box-sizing: border-box;
  }

  .title {
    font-size: 18px;
  }

  .people-list {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/session.vue